import { colors } from "config/styles/themeColors";
import { shadows } from "config/styles/shadows";
import { alpha } from "@mui/material";

const styles = {
  iconWrap: {
    boxShadow: shadows.main,
    borderRadius: "6px",
    "& svg": {
      fill: colors.background.default,
      height: "100%",
    },
    "&.MuiTypography-root.MuiLink-root": {
      height: "100%",
    },
  },
  tooltip: { backgroundColor: alpha(colors.text.secondary, 0.8) },
  tooltipArrow: { color: alpha(colors.text.secondary, 0.8) },
};

export default styles;
